import { combineReducers } from 'redux';

import query from './reducers/query';
import search from './reducers/search';

const nullReducer = state => ({ ...state });

export default combineReducers({
  query,
  paths: nullReducer,
  search
});
